import {Invoice} from "./invoice";

export class Customer {
  id: string;
  name: string;
  ico: string;
  count: number;
  sessionId: number;
  invoiceList: Invoice[];
}



// WEBPACK FOOTER //
// ./src/app/customer.ts